import { render } from "./modalBienvenida.vue?vue&type=template&id=fd7396e4"
import script from "./modalBienvenida.vue?vue&type=script&lang=js"
export * from "./modalBienvenida.vue?vue&type=script&lang=js"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__